"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useAuthStore } from "@/store/auth";

function AuthRefresher() {
  // 앱 로드 시 토큰이 있으면 /api/auth/me 한 번 호출해 user 최신화
  // (관리자가 tier 변경 시 재로그인 없이 반영되게 함)
  const token = useAuthStore((s) => s.token);
  const setUser = useAuthStore((s) => s.setUser);
  useEffect(() => {
    if (!token) return;
    axios
      .get("/api/auth/me", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUser(r.data))
      .catch(() => {});
  }, [token, setUser]);
  return null;
}

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60 * 1000, // 5분
            retry: 1,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <AuthRefresher />
      {children}
    </QueryClientProvider>
  );
}
